import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=6b240a14"
import script from "./CreateForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateForm.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports